import { render, staticRenderFns } from "./EcoIcon.vue?vue&type=template&id=1a074104&"
import script from "./EcoIcon.vue?vue&type=script&lang=js&"
export * from "./EcoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports